import { DASHBOARD_PATH } from '@helpers/constants';
import { atom } from 'jotai';

const defaultHomePage = atom<string>(DASHBOARD_PATH);

export default defaultHomePage;
